export default __webpack_public_path__ + "static/CharterITCW05-Italic-c8878f78b821b24d6f3bf88acd81aabe.woff2";